import React, { } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, Text, ResponsiveContainer } from 'recharts';
import { colors_reports } from '../../constants/colors_reports';

const dataKey = [
  "peritajes"
]

function ServicesByMonth({ data }) {
  return (
    <div className="mt-2">
      <Text x={300} y={30} fontSize={30} fontWeight="bold" textAnchor="middle">
        Servicios prestados por mes
      </Text>
      <ResponsiveContainer width="95%" height={400} >
        <BarChart height={400} data={data} layout="vertical" >
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis type="number">
            <Label value='Número de servicios realizados' position={'insideBottomRight'} />
          </XAxis>
          <YAxis dataKey="month_year" type="category" />
          <Tooltip />
          <Legend />
          {
            dataKey.map((element, i) => {
              return (
                <Bar key={i} dataKey={element} fill={colors_reports[i]} />
              )
            })
          }
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ServicesByMonth;